<template>
    <!-- MA print hidden area -->
    <div id="manufacturingPrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center;padding-bottom:5px">
        <p style="font-size:15px;margin:0px;font-weight:bold;">{{ shopName }}</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:0px"
        >Mnaufacturing Account</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:0px"
        >From [{{fromMonth}}] To [{{toMonth}}]</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter"></p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="counter">Shop Code: {{ shopCode }}</p>
      </div>
      <br />

      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr style="line-height: 20px;">
              <th style="border:1px solid black;text-align:center">Account Code</th>
              <th style="border:1px solid black;text-align:center">Account Name</th>
              <th style="border:1px solid black;text-align:center">SubAccount Amount</th>
              <th style="border:1px solid black;text-align:center">Amount</th>
            </tr>
          </thead>
          <!-- Start ORIGINAL_COST -->
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >Original Cost</td>
          </tr>
          <tbody
            v-for="(item, index) in maModel.manufacturingParentAccountList.filter((v)=>v.sessionName == 'ORIGINAL_COST' && (balanceType == 'ALL' ? true : v.totalAmount != 0))"
            :key="'RM'+index"
          >
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat}})</span>
                <span v-else>{{item.totalAmount | decFormat}}</span>
              </td>
            </tr>
             <!-- for sub account -->
            <tr v-for="(itemdetail, index) in item.manufacturingDetailAccountList"
            :key="'RMD'+index" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">{{itemdetail.amount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <!-- end sub account -->
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Original Cost</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.originalCost | decFormat}}</td>
          </tr>
          <!-- End ORIGINAL_COST -->

          <!-- start PRODUCTION_COST -->
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >Production Cost</td>
          </tr>
          <tbody
            v-for="(item, index) in maModel.manufacturingParentAccountList.filter((v)=>v.sessionName == 'PRODUCTION_COST' && (balanceType == 'ALL' ? true : v.totalAmount != 0))"
            :key="'WIP'+index"
          >
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat}})</span>
                <span v-else>{{item.totalAmount | decFormat}}</span>
              </td>
            </tr>
            <tr v-for="(itemdetail, i) in item.manufacturingDetailAccountList"
            :key="'WIPD'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Production Cost</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.productionCost | decFormat}}</td>
          </tr>
          <!-- End PRODUCTION_COST -->

          <!-- Start TOTAL PRODUCTION_COST -->
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Production Cost</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.totalProductionCost | decFormat}}</td>
          </tr>
          <!-- End TOTAL PRODUCTION_COST -->

          <!-- start PRODUCTION_VALUE -->
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >Production Value</td>
          </tr>
          <tbody
            v-for="(item, index) in maModel.manufacturingParentAccountList.filter((v)=>v.sessionName == 'PRODUCTION_VALUE' && (balanceType == 'ALL' ? true : v.totalAmount != 0))"
            :key="'DO'+index"
          >
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat}})</span>
                <span v-else>{{item.totalAmount | decFormat}}</span>
              </td>
            </tr>

            <tr v-for="(itemdetail, i) in item.manufacturingDetailAccountList"
            :key="'DOD'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Production Value</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.productionValue | decFormat}}</td>
          </tr>
          <!-- End PRODUCTION_VALUE -->

          <!-- Start TOTAL PRODUCTION_VALUE -->
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Production Value</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.totalProductionValue | decFormat}}</td>
          </tr>
          <!-- End TOTAL PRODUCTION_VALUE -->

          <!-- start VALUE_OF_GOODS_SOLD -->
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >Value Of Goods Sold</td>
          </tr>
          <tbody
            v-for="(item, index) in maModel.manufacturingParentAccountList.filter((v)=>v.sessionName == 'VALUE_OF_GOODS_SOLD' && (balanceType == 'ALL' ? true : v.totalAmount != 0))"
            :key="'FO'+index"
          >
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat}})</span>
                <span v-else>{{item.totalAmount | decFormat}}</span>
              </td>
            </tr>

            <tr v-for="(itemdetail, i) in item.manufacturingDetailAccountList"
            :key="'FOD'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Value Of Goods Sold</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.valueOfGoodsSold | decFormat}}</td>
          </tr>
          <!-- end VALUE_OF_GOODS_SOLD -->

          <!-- Total VALUE_OF_GOODS_SOLD -->
          <tr style="line-height: 20px;">
            <td
              colspan="3"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Value Of Goods Sold</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{maModel.totalValueOfGoodsSold | decFormat}}</td>
          </tr>
          <!--Total VALUE_OF_GOODS_SOLD -->
          
        </table>
        <div style="height:10px"></div>
      </div>
    </div>
</template>
<script>
export default {
  props: [
    "maModel",
    "shopName",
    "shopCode",
    "fromMonth",
    "toMonth",
    "balanceType",
  ],
};
</script>
